import React from "react";
import { BsFillCaretDownFill } from "react-icons/bs";
import ComponentHeader from "./ComponentHeader";
import { useNavigate } from "react-router-dom";
import ReactDatePicker from "react-datepicker";
import { forwardRef } from "react";
import { useState } from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import NewMemberSvg from "../../svg/NewMemberDash.svg";
import TotalMemberSvg from "../../svg/TotalMember.svg";
import { getMembers } from "../../services/DashboardService";
import moment from "moment";
import { useEffect } from "react";
import { useDateTimezone } from "../../Context/DateTimezoneContext";
import { useAuth } from "../../Context/AuthContext";
function Dash_Member() {
  const {isAdmin} = useAuth();
  const navigate = useNavigate();
  const [calFilter, setCalFilter] = useState(new Date());
  const [member, setMember] = useState();
  const {dashboardDate} = useDateTimezone()


  useEffect(()=>{
    setCalFilter(dashboardDate)
  },[dashboardDate])

  useEffect(()=>{
    getMemberss(moment(calFilter).format("YYYY-MM-DD"))
  },[calFilter])

  const getMemberss = async(date) =>{
    try {
      const response = await getMembers(date)
      if(response.status === 200){
        setMember(response?.data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  // Calander DropDown
  const CustomDatePicker = forwardRef(({ value, onClick }, ref) => (
    <div className="d-flex align-items-center gap-1">
      {/* <span className="fw-semibold ms-2" style={{ fontSize: "18px", color:'rgba(31, 126, 120, 1)' }}>
        {(new Date(value).getDate() === new Date().getDate()
          ? "Today"
          : value) || "Today"}
      </span> */}
      <button className="btn" onClick={onClick} ref={ref}>
        {/* <span>{value}</span> */}
        <BsFillCaretDownFill color="rgba(31, 126, 120, 1)" />
      </button>
    </div>
  ));
  return (
    <>
      <ComponentHeader
        title={"Member"}
        filter={
          <ReactDatePicker
            dateFormat="MM-dd-yyyy"
            selected={calFilter}
            className="description_inputf mb-0"
            minDate={new Date("01-01-1720")}
            maxDate={new Date()}
            showMonthDropdown
            showYearDropdown
            yearDropdownItemNumber={300}
            scrollableYearDropdown
            onChange={(date) => setCalFilter(date)}
            customInput={<CustomDatePicker />}
            placeholderText="mm-dd-yyyy"
          />
        }
        descript={moment(new Date(calFilter)).format('MM-DD-YYYY') === moment(new Date()).format('MM-DD-YYYY') ? 'Today' : moment(new Date(calFilter)).format('MM-DD-YYYY')}
      />
      <div
        style={{ height: "236px" }}
        className="shadow rounded-4 mb-3 d-flex align-items-center"
      >
        <List

          sx={{ width: "100%", height: "100%", bgcolor: "background.paper" }}
          className="d-flex flex-column justify-content-center gap-2 px-3"
        >
          <ListItem className="d-flex align-items-center gap-2 pointer "
          onClick={()=>{
            if(isAdmin){
              navigate('allpatientlist?tab=0')
            }else{
              navigate('allpatientlist?tab=0')
            }}}
          sx={{"&:hover":{
            backgroundColor:'rgba(230, 230, 230, 0.2)',
          }}} >
            <ListItemAvatar
              className=""
              style={{ height: "60px", width: "60px" }}
            >
              <Avatar
                alt="Remy Sharp"
                src={NewMemberSvg}
                style={{ height: "100%", width: "100%" }}
              />
            </ListItemAvatar>
            <ListItemText
              className="text-center"
              primary={
                <React.Fragment>
                  <Typography
                    sx={{
                      display: "inline",
                      textAlign: "center",
                    }}
                    component="p"
                    variant="body1"
                    color="text.primary"
                    className="headFont"
                  >
                    {member ? member.newMembers : "--"}
                  </Typography>
                </React.Fragment>
              }
              secondary={
                <React.Fragment>
                  <Typography
                    sx={{ display: "inline"}}
                    component="span"
                    variant="body2"
                    color="text.light"
                    className="headFont"
                  >
                    New Members
                  </Typography>
                </React.Fragment>
              }
            />
            {/* <ListItemText
              className="d-flex align-itms-center justify-content-center  gap-2"
              primary={
                <React.Fragment>
                  <Typography
                    sx={{
                      display: "inline",
                      fontSize: "20px",
                      textAlign: "center",
                    }}
                    component="img"
                    src={MemberGraph}
                    alt="graph"
                    variant="body1"
                    color="text.primary"
                  ></Typography>
                </React.Fragment>
              }
              secondary={
                <React.Fragment>
                  <Typography
                    sx={{ display: "inline", fontSize: "20px" }}
                    component="span"
                    variant="body2"
                    color="rgba(151, 71, 255, 1)"
                  >
                    0%
                  </Typography>
                </React.Fragment>
              }
            /> */}
          </ListItem>
          <Divider variant="inset" component="li" className="m-0" />
          <ListItem className="d-flex align-items-center gap-2 pointer" onClick={()=>{
            if(isAdmin){
              navigate('allpatientlist?tab=1')
            }else{
              navigate('allpatientlist?tab=2')
            }
          }} sx={{"&:hover":{
            backgroundColor:'rgba(230, 230, 230, 0.2)',
          }}} >
            <ListItemAvatar
              className=""
              style={{ height: "60px", width: "60px" }}
            >
              <Avatar
                alt="Remy Sharp"
                src={TotalMemberSvg}
                style={{ height: "100%", width: "100%" }}
              />
            </ListItemAvatar>
            <ListItemText
              className="text-center"
              primary={
                <React.Fragment>
                  <Typography
                    sx={{ display: "inline" }}
                    component="p"
                    variant="body1"
                    color="text.primary"
                    className="headFont"
                  >
                    {member ? member.totalMembers : "--"}
                  </Typography>
                </React.Fragment>
              }
              secondary={
                <React.Fragment>
                  <Typography
                    sx={{ display: "inline" }}
                    component="span"
                    variant="body2"
                    color="text.light"
                    className="headFont"
                  >
                    Total Members
                  </Typography>
                </React.Fragment>
              }
            />
            {/* <ListItemText
              className="d-flex align-items-center gap-2 justify-content-center "
              primary={
                <React.Fragment>
                  <Typography
                    sx={{
                      display: "inline",
                      fontSize: "20px",
                      textAlign: "center",
                    }}
                    component="img"
                    src={MemberGraph}
                    alt="graph"
                    variant="body1"
                    color="text.primary"
                  ></Typography>
                </React.Fragment>
              }
              secondary={
                <React.Fragment>
                  <Typography
                    sx={{ display: "inline", fontSize: "20px" }}
                    component="span"
                    variant="body2"
                    color="rgba(151, 71, 255, 1)"
                  >
                    0%
                  </Typography>
                </React.Fragment>
              }
            /> */}
          </ListItem>
        </List>
      </div>
    </>
  );
}

export default Dash_Member;
